import {createContext, useContext, useEffect, useState} from 'react'

import * as persisted from '#/state/persisted'

const stateContext = createContext(Boolean(persisted.defaults.leftNavCollapsed))
stateContext.displayName = 'LeftNavCollapsedStateContext'

const setContext = createContext<(_: boolean) => void>(() => {})
setContext.displayName = 'LeftNavCollapsedSetContext'

export function Provider({children}: React.PropsWithChildren<{}>) {
  const [state, setState] = useState(() =>
    Boolean(persisted.get('leftNavCollapsed')),
  )

  const setStateWrapped = (collapsed: boolean) => {
    setState(collapsed)
    void persisted.write('leftNavCollapsed', collapsed)
  }

  useEffect(() => {
    return persisted.onUpdate('leftNavCollapsed', nextCollapsed => {
      setState(Boolean(nextCollapsed))
    })
  }, [])

  return (
    <stateContext.Provider value={state}>
      <setContext.Provider value={setStateWrapped}>
        {children}
      </setContext.Provider>
    </stateContext.Provider>
  )
}

export function useLeftNavCollapsed() {
  return useContext(stateContext)
}

export function useSetLeftNavCollapsed() {
  return useContext(setContext)
}
